// initial state
const state = {
  copyright: (new Date()).getFullYear() + ' APUS云服务及工程效率平台 前端组出品'
}

// getters
const getters = {
  footer: state => state
}

export default {
  state,
  getters
}
